import type { TravelerType } from './types';

/**
 * Classify an organization's traveller type from its free-text title. Traveller
 * types carry no explicit kind, only a title and an age range, so the title is
 * the rule: "Adults" → adult, "Children" → child, and so on.
 *
 * The one copy the pricing adapters (backend and frontend) and the product
 * list's display price read, so "adult" means the same thing everywhere.
 */
export const normalizeTravelerType = (
  value: string | null | undefined
): TravelerType => {
  const normalized = value?.toLowerCase() ?? '';

  if (normalized.includes('child')) {
    return 'child';
  }

  if (normalized.includes('teen')) {
    return 'teen';
  }

  if (normalized.includes('baby') || normalized.includes('infant')) {
    return 'baby';
  }

  if (normalized.includes('senior')) {
    return 'senior';
  }

  if (normalized.includes('adult')) {
    return 'adult';
  }

  return 'unknown';
};
